import EvalStepFooter from './src/main';

/* istanbul ignore next */
EvalStepFooter.install = function(Vue) {
  Vue.component(EvalStepFooter.name, EvalStepFooter);
};

export default EvalStepFooter;
